import { render, staticRenderFns } from "./custConvertListProduct.vue?vue&type=template&id=66131baa&scoped=true"
import script from "./custConvertListProduct.vue?vue&type=script&lang=js"
export * from "./custConvertListProduct.vue?vue&type=script&lang=js"
import style0 from "./custConvertListProduct.vue?vue&type=style&index=0&id=66131baa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66131baa",
  null
  
)

export default component.exports